"use client";

/**
 * β-8 N6 — 모든 sub 페이지의 뒤로가기 ← 일관성.
 * BottomNav 메인 페이지 (홈/공급처/지도/매장/커뮤니티/MY) 는 안 사용.
 */
import { useRouter } from "next/navigation";
import Link from "next/link";

interface Props {
  title: string;
  /** 뒤로 갈 경로. 미지정 시 router.back() */
  backHref?: string;
  /** 우측 액션 버튼 (선택) */
  right?: React.ReactNode;
}

export function PageHeader({ title, backHref, right }: Props) {
  const router = useRouter();
  return (
    <div className="sticky top-0 z-40 bg-bg/90 backdrop-blur-md border-b border-border px-4 py-3 flex items-center gap-3">
      {backHref ? (
        <Link href={backHref} className="text-text-sub hover:text-text transition-colors">
          ←
        </Link>
      ) : (
        <button
          onClick={() => router.back()}
          className="text-text-sub hover:text-text transition-colors"
          aria-label="뒤로"
        >
          ←
        </button>
      )}
      <h1 className="text-base font-black text-text flex-1 truncate">{title}</h1>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}
